import { useEffect, useState, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useFormik } from "formik";
import {
  removeToken,
  setToken,
  setDealAndToken,
  getCurrentDateForPrompt, 
  commentBeautify,
  formatLetterTextToHTML,
  addClassToEmptyPTags,
  sendGridEmailTextMargin} from "../shared/Helpers";
import getAccessToken from "../app/services/getAccessToken";
import getUser from "../app/services/getUser";
import { useLocation, useNavigate } from "react-router-dom";
import updateUser from "../app/services/updateUser";
import Circle from "../assets/img/check_circle.svg";
import Back from "../assets/img/back_1.svg";
import Note from "../assets/img/note.svg";
import Mail from "../assets/img/mail.svg";
import sendMailToEmployer from "../app/services/sendMailToEmployer";
import updateLetter from "../app/services/updateLetter";
import Cycle from "../assets/img/cycle.svg";
import { Toast } from "primereact/toast";
import getSupervisorList from "../app/services/getSupervisorList";
import rotaGateway from "../app/services/rotaGateway";
import ErrorMessage from "../components/ErrorMessage";
import EmployerConfirmPopup from "../components/EmployerConfirmPopup";
import saveDraftLawyer from "../app/services/saveDraftLawyer";
import previewLetterPdf from "../app/services/previewLetterPdf";

const InternalReviewLetter = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const dealAndToken = queryParams.get("customer");
  const toast = useRef(null);
  const [showEmployerPopup, setshowEmployerPopup] = useState(false);
  const [rotaDealInformation, setRotaDealInformation] = useState();
  // const [isAtjPipeline, setIsAtjPipeline] = useState('no');
  const [employerEmailState, setEmployerEmailState] = useState('');
  const [updateStatus, setUpdateStatus] = useState('');
  const [commentApiStatus, setCommentApiStatus] = useState('');
  const [updateStatusType, setUpdateStatusType] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isLetterSubmitted, setLetterSubmitted] = useState(false);
  const [isLetterSentToEmployee, setLetterSentToEmployee] = useState(false);
  const [wpLetterPdfName, setWpLetterPdfName] = useState('Wp Letter');
  const [dealID, setDealID] = useState("");
  const [encryptedDealID, setEncryptedDealID] = useState("");
  const [userDetails, setUserDetails] = useState({});
  const [charCount, setCharCount] = useState(0);
  const maxCharLimit = 5000;
  const [authToken, setAuthToken] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmittingText, setIsSubmittingText] = useState('Submitting');
  const [commentToClients, setCommentToClient] = useState(false);
  const [buttonClicked, setButtonClicked] = useState("");
  const [supervisorList, setSupervisorList] = useState([]);
  const [selectedSupervisor, setSelectedSupervisor] = useState("");
  const [error, setError] = useState(null);
  const [highlightAnimation,setHighlightAnimation] = useState({
    animationClass:"",
    textClass:"",
    message:""
  });
  // eslint-disable-next-line no-unused-vars
  const [pollingInterval, setPollingInterval] = useState(null);
  const [editorContent, setEditorContent] = useState("");
  const [dynamicEmailBody, setDynamicEmailBody] = useState({
    employerEmailBody:'',
    employeeEmailBody:'',
    lawyerSignature:''
  });
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isPdfOpen, setIsPdfOpen] = useState(false);
  const handleError = (error, type, description) => {
    console.error(description, error);
    setError({ error, type, description });
  };

  // Auto-reset after 5 seconds
  useEffect(() => {
    if ( highlightAnimation.message === 'Draft is saved successfully' ) {
      const timeout = setTimeout(() => {
        setHighlightAnimation({
          animationClass: "",
          textClass: "",
          message: "",
        });
      }, 5000);

      return () => clearTimeout(timeout); // cleanup on unmount or re-trigger
    }
  }, [highlightAnimation]);

  useEffect(() => {
    const decryptAndFetchToken = async () => {
      if (dealAndToken) {
        try {
          const { data } = await getAccessToken(dealAndToken);
          const userDetails = await getUser(data.token);
           
          const selectedSupervisor = userDetails.data.Supervisor ?? "";
          setSelectedSupervisor(selectedSupervisor);
          const supervisors = await getSupervisorList();
          const supervisorList =
            supervisors.data.data.attributes.SupervisorList;
          setSupervisorList(supervisorList);

          setAuthToken(data.token);
          setToken(data.token);

          const {data:rotaDealInformation} = await rotaGateway({
            method: 'POST',
            path: 'v1/get-deal-details',
            body: {
              dealID: userDetails.data.dealID,
              deal_access_token: data.token,
            },
          });
          setEmployerEmailState(rotaDealInformation.employer_email);
          if(rotaDealInformation){
            const apiSign = rotaDealInformation?.lawyer_sign ? rotaDealInformation?.lawyer_sign : rotaDealInformation?.default_sign;
            const employeeBody = rotaDealInformation?.employee_body.replace(/{client_name}/g, userDetails.data.name);
            setDynamicEmailBody({
              employerEmailBody: rotaDealInformation?.employer_body,
              employeeEmailBody: employeeBody,
              lawyerSignature: apiSign
            })
          }
          setRotaDealInformation(rotaDealInformation);
          // setIsAtjPipeline(rotaDealInformation.is_atj_pipeline);
          setDealAndToken(dealAndToken);
          setDealID(userDetails.data.dealID);
          setEncryptedDealID(userDetails.data.encryptedDealID);
          setUserDetails(userDetails.data);
          setLetterSubmitted(userDetails.data.wpLetterSubmittedToLawyers);
          setLetterSentToEmployee(userDetails.data.wpLetterSubmittedToEmployee);
          if(userDetails?.data?.survey?.fullname){
              setWpLetterPdfName(`WP Letter ${userDetails?.data?.survey?.fullname}` );
          }

          if (!userDetails.data.checkedWpLetter) {
            let cancelled = false;
            let timeoutId = null;
            const poll = async () => {
              if (cancelled) return;
              try {
                const { data } = await getAccessToken(dealAndToken);
                if (cancelled) return;
                const updatedUserDetails = await getUser(data.token);
                if (cancelled) return;
                setToken(data.token);
                setUserDetails(updatedUserDetails.data);
                if (updatedUserDetails.data.checkedWpLetter) {
                  setEditorContent(formatLetterTextToHTML(updatedUserDetails.data.checkedWpLetter));
                  setIsLoading(false);
                  return;
                }
              } catch (error) {
                console.error("Error polling for the letter:", error);
              }
              if (!cancelled) {
                timeoutId = setTimeout(poll, 45000);
              }
            };
            poll();
            return () => {
              cancelled = true;
              if (timeoutId) clearTimeout(timeoutId);
            };
          }

          setEditorContent(formatLetterTextToHTML(userDetails.data.checkedWpLetter));
          setIsLoading(false);
        } catch (error) {
          handleError(error, 'fetch', "Error loading page");
        }
      } else {
        removeToken();
        console.error("No dealAndToken provided in URL");
        navigate("/login");
      }
    };

    decryptAndFetchToken();
  }, [navigate, dealAndToken]);

  const cancel = () => {
    setCommentToClient(false);
  };

  const enableCommentToClient = () => {
    setCommentToClient(true);
  };

  const employerFormSubmit = async (confirmData={},submitType='liveLetter') => {
    setIsSubmitting(true);
    const timestamp = new Date();
    const baseUrl = window.location.origin;
    const employerEmail = confirmData.employerEmailId || employerEmailState || userDetails.survey.contact_email;
    if (dealID) {
      try {
        if(submitType === 'liveLetter'){
          //***************** Submit Data IN Rota Gatway *****************//
          const payload = {
            dealID: dealID,
            comment: `Final comment before sending it to employer: ${formik.values.letterFeedback}`,
            wpLetterUrl: `${baseUrl}/internal-review?customer=${dealAndToken}`,
            stage: "employee",
            ...(formik.values.letterSupervisor && {
              letterSupervisor: formik.values.letterSupervisor,
            }),
            employerEmail:employerEmail
          };
          const rotaRes = await rotaGateway({
            method: 'POST',
            path: 'v1/submit-letter',
            body: payload,
          });
          if(rotaRes.status !== 200){
            setUpdateStatus('Something Were Wrong!!');
            setUpdateStatusType('error');
            throw new Error('Something Were Wrong!!');
          }
          //***************** Update User In Strapi *****************//
          const updateField = {
            checkedWpLetter: formik.values.checkedWpLetter,
            internalComments: formik.values.letterFeedback,
            premium: true,
            wpLetterSubmittedToEmployee: true,
            wpLetterSetOn: timestamp,
            ...(formik.values.letterSupervisor && {
              Supervisor: formik.values.letterSupervisor,
            }),
            survey:{
              ...userDetails.survey,
              contact_email: employerEmail
            }
          };
          const strapiRes = await updateUser(authToken, updateField);
          if(strapiRes.status !== 200){
            setUpdateStatus('Something Were Wrong!!');
            setUpdateStatusType('error');
            throw new Error('Something Were Wrong!!');
          }
        }
        //***************** Employer Email *****************//
        // Get Latest Letter From State & Add Custom P tag with class "grapple-lawyer-paragraph"
         const processedContent = addClassToEmptyPTags(editorContent);
         // Remove empty P tag without custom class "grapple-lawyer-paragraph"
        const cleanedHtml = formatLetterTextToHTML(processedContent);
        const toEmailId = submitType === 'liveLetter' ? employerEmail : confirmData?.testEmailId;
        // Employer Email
        // const dynamicEmailText = isAtjPipeline === 'no' ? confirmData?.dynamicEmailBody : dynamicEmailBody?.employerEmailBody + dynamicEmailBody?.lawyerSignature; 
        const dynamicEmailText = confirmData?.dynamicEmailBody; 

        const employerEmailBody = sendGridEmailTextMargin(dynamicEmailText);
        // Employee Email
        const dynamicEmailTextEmployee = confirmData?.dynamicEmailBodyEmployee || dynamicEmailBody?.employeeEmailBody + dynamicEmailBody?.lawyerSignature; 
        const employeeEmailBody = sendGridEmailTextMargin(dynamicEmailTextEmployee);

        // Local - 6c91e051288043b3808b54057f5e1cff
        // Stage - b73eb8637e514d9c859d2ad382e61973
        // Live - 07dcb732c0a2490b9d2e21b4c667388d

        const sendGridRes = await sendMailToEmployer(
          toEmailId, //Employer Email
          userDetails.survey.contact_name, //Employer Name
          cleanedHtml,
          wpLetterPdfName,
          "d-6c91e051288043b3808b54057f5e1cff",
          dealID,
          userDetails.name, // Client Name
          userDetails.email, // Client Email
          encryptedDealID,
          employerEmailBody, // Employeer Email
          employeeEmailBody, // Employee Email
          submitType,
          confirmData.emailSubject
        );
        if(sendGridRes.status !== 200){
          setUpdateStatus('Something Were Wrong!!');
          setUpdateStatusType('error');
          throw new Error('Something Were Wrong!!');
        }
        setUpdateStatus('Email Send Successfully.')
        setUpdateStatusType('success');
        // ATJ Pipeline Redirect
        if(submitType === 'liveLetter'){
          navigate("/request-submitted");
        }
      } catch (error) {
        handleError(error, 'submit', "Error generating and showing the letter (sendToEmployer)");
      } finally {
        setIsSubmitting(false);
      }
    }
  }

  const formik = useFormik({
    initialValues: {
      letterFeedback: "",
      checkedWpLetter: "",
      letterSupervisor: "",
      commentToClient: "",
    },
    validate: (values) => {
      const errors = {};
      if (buttonClicked === "sendToGpt" && !values.letterFeedback) {
        errors.letterFeedback = "Required";
      }
      if (
        buttonClicked === "sendToEmployer" &&
        !values.letterSupervisor &&
        !selectedSupervisor
      ) {
        errors.letterSupervisor = "Please select a supervisor";
      }
      return errors;
    },
    onSubmit: async (values) => {
      if (buttonClicked === "sendToGpt") {
        if (dealID) {
          setIsSubmitting(true);
          try {
            const formData = {
              userId: userDetails.id,
              name: userDetails.name,
              email: userDetails.email,
              dealID: userDetails.dealID,
              checkedWpLetter: values.checkedWpLetter,
              internalComments: values.letterFeedback,
              paragraph: `Today's date: ${getCurrentDateForPrompt()}\n\nComment:\n\n${values.letterFeedback}\n\nLetter:\n\n${values.checkedWpLetter}`,
            };
            await updateLetter(formData);
            window.location.reload();
          } catch (error) {
            handleError(error, 'submit', "Error generating and showing the letter (sendToGpt)");
          } finally {
            setIsSubmitting(false);
          }
        }
      } else if (buttonClicked === "previewPDF") {
        setIsSubmittingText('Generating PDF');
        setIsSubmitting(true);
        try {
          // Get Latest Letter From State & Add Custom P tag with class "grapple-lawyer-paragraph"
          const processedContent = addClassToEmptyPTags(editorContent);
          const saveDraftPayload = {
            dealID: dealID,
            processedContent:processedContent,
            clientName:userDetails.name
          };
          const draftResponse = await previewLetterPdf(authToken,saveDraftPayload);
          const blob = new Blob([draftResponse.data], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);
          setPdfUrl(url);
          setIsPdfOpen(true);
          // window.open(url); // PDF preview
        } catch (error) {
            handleError(error, 'submit', "Error generating and showing the letter (saveDraft)");
        } finally {
          setIsSubmitting(false);
          setIsSubmittingText('Submitting');
        }
      } else if (buttonClicked === "saveDraft") {
        setIsSubmitting(true);
        try {
          // Get Latest Letter From State & Add Custom P tag with class "grapple-lawyer-paragraph"
          const processedContent = addClassToEmptyPTags(editorContent);
          // Remove empty P tag without custom class "grapple-lawyer-paragraph"
          const cleanedHtml = formatLetterTextToHTML(processedContent);
          const updateField = {
            checkedWpLetter: cleanedHtml,
            internalComments: values.letterFeedback,
          };
          const res = await updateUser(authToken, updateField);
          const saveDraftPayload = {
            dealID: dealID,
            processedContent:processedContent,
            clientName:userDetails.name
          };
          console.log('saveDraftPayload', saveDraftPayload)
          const draftResponse = await saveDraftLawyer(authToken,saveDraftPayload);
          console.log('draftResponse-------------', draftResponse)

          if(res.status === 200){
            setHighlightAnimation({
              animationClass:"letterAnimation green",
              textClass:"green",
              message:"Draft is saved successfully"
            });
          } 
        } catch (error) {
            handleError(error, 'submit', "Error generating and showing the letter (saveDraft)");
        } finally {
          setIsSubmitting(false);
        }
      } else if (buttonClicked === "approve") {
        if (dealID) {
          setIsSubmitting(true);
          try {
            const baseUrl = window.location.origin;
            const payload = {
              dealID: dealID,
              comment: `Letter for review by trainee comment: ${values.letterFeedback}`,
              wpLetterUrl: `${baseUrl}/internal-review?customer=${dealAndToken}`,
              stage: "lawyer",
              ...(values.letterSupervisor && {
                letterSupervisor: values.letterSupervisor,
              }),
            };
            await rotaGateway({
              method: 'POST',
              path: 'v1/submit-letter',
              body: payload,
            });
            const updateField = {
              checkedWpLetter: values.checkedWpLetter,
              ...(values.letterFeedback && {
                internalComments: values.letterFeedback,
              }),
              wpLetterSubmittedToLawyers: true,
              ...(values.letterSupervisor && {
                Supervisor: values.letterSupervisor,
              }),
            };
            await updateUser(authToken, updateField);
            toast.current.show({
              severity: "success",
              summary: "Success",
              detail:
                "Thanks for Approving this letter in the first instance. You can now continue to send the letter to employer, or to get supervision, as appropriate.",
              life: 5000,
            });
            setTimeout(() => {
              window.location.reload();
            }, 5000);
          } catch (error) {
            handleError(error, 'submit', "Error generating and showing the letter (approve)");
          } finally {
            setIsSubmitting(false);
          }
        }
      } else if (buttonClicked === "sendToEmployer") {
        employerFormSubmit();
      } else if (buttonClicked === "sendToClient") {
          const baseUrl = window.location.origin;
          if (dealID && values.commentToClient) {
          setIsSubmitting(true);
          try {

            const formattedComments = Array.isArray(userDetails.comments) ? userDetails.comments.map(
                                        (comment) => {
                                          const date = comment.timestamp ? new Date(comment.timestamp).toLocaleDateString("en-GB") : "";
                                          return [
                                            "_________________",
                                            `${comment.type} (message sent on ${date}): ${comment.comment}`,
                                          ].join("\n");
                                        }).join("\n")
                                    : "";
        const today = new Date().toLocaleDateString("en-GB");
        let newComment = ''
        if (values.commentToClient) {
          newComment = [
            "_________________",
            `Internal (message sent on ${today}): ${values.commentToClient}`,
          ].join("\n");
        }
        // FINAL TEXT
        const finalText = [formattedComments, newComment]
          .filter(Boolean)
          .join("\n");

            const payload = {
              dealID: dealID,
              commentToClient: finalText,
              wpLetterUrl: `${baseUrl}/internal-review?customer=${dealAndToken}`,
              stage: "client",
            };
            const rotares = await rotaGateway({
              method: 'POST',
              path: 'v1/submit-letter',
              body: payload,
            });
            if(rotares.status !== 200){
              setCommentApiStatus('Error in submitting the comment, Please try again or reach our to the tech team.');
              throw new Error('ROTA PD API error. Please try again.');
            }

            const updateField = {
              comments: [
                ...(userDetails.comments || []),
                {
                  comment: values.commentToClient ?? "[no comment]",
                  timestamp: new Date().toISOString(),
                  type: "Internal",
                },
              ],
              SentBackToClient: true,
              ClientAnswered: false,
            };
            const updatedData = await updateUser(authToken, updateField);
            if(updatedData.status !== 200){
              setCommentApiStatus('Error in submitting the comment, Please try again or reach our to the tech team.');
              throw new Error('StrapiAPI error. Please try again.');
            }
            setUserDetails(updatedData.data);
            formik.setFieldValue('commentToClient', '');
          } catch (error) {
            handleError(error, 'submit', "Error generating and showing the letter (sendToClient)");
          } finally {
            setIsSubmitting(false);
          }
        }
      }
    },
  });
  useEffect(() => {
    if (
      userDetails.internalComments !== undefined ||
      userDetails.userComments !== undefined
    ) {
      formik.setValues({
        letterFeedback:
          userDetails.internalComments || userDetails.userComments || "",
      });
    } else {
      formik.setValues({
        letterFeedback: "", // Set it to empty if both are undefined
      });
    }

    if (
      userDetails.checkedWpLetter &&
      !userDetails.wpLetterSubmittedToChatGPT
    ) {
      let formattedContent = userDetails.checkedWpLetter.replace(
        /^#+\s*(.*)$/gm,
        "<strong>$1</strong>"
      );

      // Replace markdown bold syntax (e.g., **bold**) with <strong>.
      formattedContent = formattedContent.replace(
        /\*\*(.*?)\*\*/g,
        "<strong>$1</strong>"
      );

      // Replace newlines with <br /> where necessary, but avoid adding <br /> next to <p>, </p>, or where there are duplicate <br />s.
      formattedContent = formattedContent.replace(
        /([^\n])\n(?!<br>)(?<!<\/p>)(?!<p>)/g,
        "$1<br />"
      );

      // Remove any spaces directly inside <p> tags.
      formattedContent = formattedContent
        .replace(/<p>\s+/g, "<p>") // Remove space after opening <p> tag
        .replace(/\s+<\/p>/g, "</p>"); // Remove space before closing </p> tag

      // Remove empty <p></p> tags (even if there are spaces or newlines in between).
      formattedContent = formattedContent.replace(/<p>\s*<\/p>/g, "");

      // Remove <p><br></p> tags (including those with spaces or variations in <br> tag formatting).
      formattedContent = formattedContent.replace(
        /<p>\s*<br\s*\/?>\s*<\/p>/g,
        ""
      );

      // Set the field value in Formik to update the state.
      formik.setFieldValue("checkedWpLetter", formattedContent || "<p></p>");
    } else {
      formik.setFieldValue(
        "checkedWpLetter",
        userDetails.checkedWpLetter || "<p></p>"
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDetails]);

  return (
    <div className="letter client-review internal">
      <div className="letter-header-message">
        {isLetterSubmitted && (
          <div className="letter-header">
            <p>
              WP Letter For Review
            </p>
            Edit, Send to Chat GPT, Send Back to Client, & Send to Employer
          </div>
        )}
        {!isLetterSubmitted && (
          <div className="letter-header">
            <p>
              WP Letter For Review
            </p>
            Edit, Send to Chat GPT, Send Back to Client & Send to Employer
          </div>
        )}
      </div>
      <div className="letter-content">
        <form onSubmit={formik.handleSubmit}>
          <div className="comment">
            <label htmlFor="letterFeedback">
              Enter text here to Send to Chat GPT. It will automatically include a 
              <a
                href="https://docs.google.com/document/d/1_q01t0xxvPUlUymLXhJ7DpMyRlZs6sVqidXSX_4EY3g/edit"
                target="_blank"
                rel="noreferrer"
              >prompt</a>
              to update the letter.
            </label>
            <button
              type="submit"
              name="submit_button_1"
              onClick={() => setButtonClicked("sendToGpt")}
              disabled={isSubmitting}
            >
              <img src={Note} width="auto" height="auto" alt="circle" />
              Send to ChatGPT
            </button>
            <textarea
              id="letterFeedback"
              name="letterFeedback"
              maxLength={maxCharLimit}
              onChange={(e) => {
                formik.handleChange(e);
                setCharCount(e.target.value.length);
              }}
              value={formik.values.letterFeedback}
            />
            <span>
              {charCount}/{maxCharLimit}
            </span>
          </div>
          <div className="letter-header-content">
            <h5>Edit, Save Draft & Send Back to Client</h5>
            {isLetterSubmitted && <p>for review by Supervisor</p>}
            {!isLetterSubmitted && <p>for review by Lawyer</p>}
            {/* Chat UI for Comments */}
            {userDetails.comments && userDetails.comments.length > 0 && (
              <div className="comments-chat">
                <h6>Comments History</h6>
                <div className="comments-list">
                  {userDetails.comments.map((comment, index) => (
                    <div
                      key={index}
                      className={`comment-item ${
                        comment.type === "Internal"
                          ? "left-align"
                          : "right-align"
                      }`}
                    >
                      <p className="comment-type">
                        {comment.type === "Internal" ? "Lawyer" : comment.type}{" "}
                        <span className="comment-timestamp">
                          {new Date(comment.timestamp).toLocaleString()}
                        </span>
                      </p>
                      <div className="commentHtml"
                        dangerouslySetInnerHTML={{
                          __html: commentBeautify(comment.comment ?? "[no comment]"),
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div className="letter-content-header">
              {!isLoading && (
                <>
                  <div className="letter-actions">
                    <button type="button" onClick={enableCommentToClient}>
                      <img src={Back} width="auto" height="auto" alt="circle" />
                      Back to Client
                    </button>
                    <button
                      type="submit"
                      name="submit_button_2"
                      onClick={() => setButtonClicked("saveDraft")}
                    >
                      Save Draft
                    </button>
                    <button
                      type="submit"
                      name="submit_button_2"
                      onClick={() => setButtonClicked("previewPDF")}
                    >
                      Preview PDF
                    </button>
                  </div>
                  <div className="letter-actions">
                    <div>
                      <select
                        name="letterSupervisor"
                        id="letterSupervisor"
                        value={formik.values.letterSupervisor || selectedSupervisor} // Use selectedSupervisor as the default
                        onChange={formik.handleChange} // Handle Formik change
                      >
                        <option value="" label="Select Supervisor" />
                        {supervisorList &&
                          supervisorList?.supervisors?.map((supervisor, index) => (
                            <option key={index} value={supervisor}>
                              {supervisor}
                            </option>
                          ))}
                      </select>
                      {formik.errors.letterSupervisor && (
                        <div className="error-message">
                          {formik.errors.letterSupervisor}
                        </div>
                      )}
                    </div>
                    {!isLetterSubmitted && (
                      <button
                        type="submit"
                        name="submit_button_3"
                        className="accept"
                        onClick={() => setButtonClicked("approve")}
                      >
                        <img src={Circle} width="auto" height="auto" alt="circle" />
                        Approve
                      </button>
                    )}
                    {isLetterSubmitted && !isLetterSentToEmployee && (
                      <button
                        type="submit"
                        name="submit_button_4"
                        className="accept"
                        // onClick={() => setButtonClicked("sendToEmployer")}
                        onClick={() => {
                          // Allow Popup For All Pipeline
                          setshowEmployerPopup(true);
                          // if(isAtjPipeline === 'no'){
                          //     setshowEmployerPopup(true);
                          // }else{
                          //     employerFormSubmit();
                          // }
                        }}
                        disabled={
                          !formik.values.letterSupervisor && !selectedSupervisor
                        }
                      >
                        <img src={Circle} width="auto" height="auto" alt="circle" />
                        Send letter to employer
                      </button>
                    )}
                  </div>
                </>
                )}
            </div>
          </div>

          {commentToClients && (
            <>
              <div className="comment toClient">
                <label htmlFor="commentToClient">
                  Input your comments to be sent to client in the covering email
                </label>
                <textarea
                  id="commentToClient"
                  name="commentToClient"
                  onChange={(e) => {
                    formik.handleChange(e);
                    setCharCount(e.target.value.length);
                  }}
                  value={formik.values.commentToClient}
                />
                {commentApiStatus && <div className="action commentApiStatus">{commentApiStatus}</div>}
                <div className="action">
                  <div className="cancel" onClick={cancel}>
                    Cancel
                  </div>
                  <button
                    type="submit"
                    name="submit_button_5"
                    className="sendToClient"
                    onClick={() => setButtonClicked("sendToClient")}
                  >
                    <img src={Mail} width="auto" height="auto" alt="circle" />
                    Send to Client
                  </button>
                </div>
              </div>
            </>
          )}
          {highlightAnimation.message && (
            <div className={`draftLetterStatus ${highlightAnimation.textClass}`}>
              <p>{highlightAnimation.message}</p>
            </div>
          )}
          <div className={`letter-content-container ${highlightAnimation.animationClass}`}>
            <div id="content" className="letter-content logged-in checkedWpLetter">
              <ReactQuill
                theme="snow"
                value={editorContent}
                onKeyDown={()=>{
                  setHighlightAnimation({
                    animationClass:"letterAnimation",
                    textClass:'red',
                    message:"Draft is not saved"
                  });
                }}
                onChange={(content) => {
                    setEditorContent(content);
                }}
                 onBlur={() => {
                    const processedContent = addClassToEmptyPTags(editorContent);
                    if (processedContent !== formik.values.checkedWpLetter) {
                      formik.setFieldValue("checkedWpLetter", processedContent);
                    }
                  }}
                modules={{
                  toolbar: [
                    [{ header: [1, 2, false] }],
                    ["bold", "italic", "underline", "strike"],
                    ["blockquote", "code-block"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    [{ script: "sub" }, { script: "super" }],
                    [{ indent: "-1" }, { indent: "+1" }],
                    [{ direction: "rtl" }],
                    [{ size: ["small", false, "large", "huge"] }],
                    [{ color: [] }, { background: [] }],
                    [{ font: [] }],
                    [{ align: [] }],
                    ["clean"],
                  ],
                }}
              />
            </div>
          </div>
        </form>
      </div>
      <ErrorMessage {...error} componentName="InternalReviewLetter" />
      {isSubmitting && (
        <div className="submit-loader">
          <div>
            <img src={Cycle} width="auto" height="auto" alt="cycle" />
            <p>{isSubmittingText}</p>
          </div>
        </div>
      )}
      {showEmployerPopup && (
        <EmployerConfirmPopup
          setshowEmployerPopup={setshowEmployerPopup}
          employerFormSubmit={employerFormSubmit}
          updateStatus={updateStatus}
          updateStatusType={updateStatusType}
          rotaDealInformation={rotaDealInformation}
          userDetails={userDetails}
          dynamicEmailBody={dynamicEmailBody}
          employerEmailPopup={employerEmailState}
        />
      )}
      {isPdfOpen && (
        <div className="pdf-modal">
          <div className="pdf-container">
            <button className="close-btn" onClick={() => setIsPdfOpen(false)}>
              ✕
            </button>
            <iframe
              src={pdfUrl}
              title="PDF Preview"
              width="100%"
              height="100%"
            />
          </div>
        </div>
      )}

      <Toast ref={toast} />
    </div>
  );
};

export default InternalReviewLetter;
